// extracted by mini-css-extract-plugin
export var closeButton = "_br-1";
export var closeX = "_br-3";
export var container = "_br-0";
export var image = "_br-2";